import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsFrontendUserCimponent extends Component {
  // Defaults
  genderOptions = [
    {
      label: 'unknown',
      value: 'unknown',
      valueText: 'unknown',
      field: 'gender',
    },
    {
      label: 'female',
      value: 'female',
      valueText: 'female',
      field: 'gender',
      selected: false,
    },
    {
      label: 'male',
      value: 'male',
      valueText: 'male',
      field: 'gender',
      selected: false,
    },
  ];

  statusOptions = [
    {
      label: 'UNCONFIRMED',
      value: 0,
      valueText: '0',
      field: 'status',
    },
    {
      label: 'APPROVAL',
      value: 1,
      valueText: '1',
      field: 'status',
      selected: false,
    },
    {
      label: 'ACTIVE',
      value: 2,
      valueText: '2',
      field: 'status',
      selected: false,
    },
    {
      label: 'REJECTED',
      value: 3,
      valueText: '3',
      field: 'status',
      selected: false,
    },
    {
      label: 'SUSPENDED',
      value: 4,
      valueText: '4',
      field: 'status',
      selected: false,
    },
    {
      label: 'DELETED',
      value: 5,
      valueText: '5',
      field: 'status',
      selected: false,
    },
    {
      label: 'ACCREDITATION',
      value: 6,
      valueText: '6',
      field: 'status',
      selected: false,
    },
  ];

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='user' as |fieldset|>
            <fieldset.field @disabled={{true}} @property='siteId' />
            <fieldset.field
              @property='status'
              @type='select-value'
              @options={{this.statusOptions}}
            />
            <fieldset.field @property='email' @type='email' />
            <fieldset.field @property='firstName' />
            <fieldset.field @property='lastName' />
            <fieldset.field @property='dob' @type='date' />
            <fieldset.field
              @property='gender'
              @type='select-value'
              @options={{this.genderOptions}}
            />
            <fieldset.field @property='company' />
            <fieldset.field @property='street' />
            <fieldset.field @property='zipCode' />
            <fieldset.field @property='city' />
            <fieldset.field @property='region' />
            <fieldset.field @property='mobileNumber' />
            <fieldset.field @property='connectId' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='channels' as |fieldset|>
            <fieldset.field
              @disabled={{true}}
              @property='channelEmail'
              @type='checkbox'
            />
          </form.fieldset>

          <form.sections.meta>
            <label>
              {{t 'meta_box.labels.lastLogin'}}
            </label>
            <div class='u-margin-bottom-small'>
              {{@model.lastLogin}}
            </div>
          </form.sections.meta>
        </div>
      </div>
    </Form>
  </template>
}
